import { FetchRecipesResponse } from '../@aligre/types/api'
import apiFetch from './apiFetch'

export default async function fetchRecipes() {
  return await apiFetch<void, FetchRecipesResponse>('recipes')
}
